export default {
    computed:{
        userCanAudit: {
            get(){
              return (this.$store.getters.getRole=="auditor" || this.$store.getters.getRole=="admin")
            }
          },
          userCanLegalAudit: {
            get(){
              return (this.$store.getters.getRole=="legal_auditor" || this.$store.getters.getRole=="admin")
            }
        }
    }
  };